import React, { useState } from 'react';
import Chrome from '../../../assets/images/dashboard/chrom.png';
import Explorer from '../../../assets/images/dashboard/explorer.png';
import Safari from '../../../assets/images/dashboard/safari.png';
import Opera from '../../../assets/images/dashboard/opera.png';
import { UL, LI, Image } from '../../../AbstractElements';
import { FaCaretDown } from 'react-icons/fa';

const BrowserUseList = () => {
  const [active, setActive] = useState(1);

  return (
    <UL className='browser-used'>
      <LI onClick={() => setActive(1)} className={`${active === 1 ? 'active' : ''}`}>
        <div className='brow-lable'>
          <span className='d-block'>+50%</span>
          <FaCaretDown />
        </div>
        <div className='browser-box'>
          <Image className='w-100 img-fluid mx-auto' src={Chrome} alt='Chrome' />
        </div>
      </LI>
      <LI onClick={() => setActive(2)} className={`${active === 2 ? 'active' : ''}`}>
        <div className='brow-lable'>
          <span className='d-block'>+60%</span>
          <FaCaretDown />
        </div>
        <div className='browser-box'>
          <Image className='w-100 img-fluid mx-auto' src={Explorer} alt='Explorer' />
        </div>
      </LI>
      <LI onClick={() => setActive(3)} className={`${active === 3 ? 'active' : ''}`}>
        <div className='brow-lable'>
          <span className='d-block'>+79%</span>
          <FaCaretDown />
        </div>
        <div className='browser-box'>
          <Image className='w-100 img-fluid mx-auto' src={Safari} alt='Safari' />
        </div>
      </LI>
      <LI onClick={() => setActive(4)} className={`${active === 4 ? 'active' : ''}`}>
        <div className='brow-lable'>
          <span className='d-block'>+90%</span>
          <FaCaretDown />
        </div>
        <div className='browser-box'>
          <Image className='w-100 img-fluid mx-auto' src={Opera} alt='Opera' />
        </div>
      </LI>
    </UL>
  );
};

export default BrowserUseList;
